import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
 import ProductCard from "../components/ProductCard";
 import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../features/products/productSlice";
import { useLocation, useNavigate ,Link} from "react-router-dom";
import ReactPaginate from 'react-paginate';
 import { useMediaQuery } from "react-responsive";
 import { brandByModel } from "../utils/brandsData";
import { IoFilter } from "react-icons/io5";
  import { MdKeyboardBackspace } from "react-icons/md";
import "../styles/listing.css"
  import noResults from "../images/no_result.gif";
import { RiGridFill } from "react-icons/ri";
import { FaCar, FaMoneyBillWave, FaCogs } from "react-icons/fa";
import { RiCalendar2Line } from "react-icons/ri";
import "../styles/filterNav.css"
import Form from "../components/FilterForm";
import FilterForm from "../components/FilterForm";
import "../styles/pagination.css"
import Pagination from "../components/Pagination";
 

const Enroute = () => {
  const [grid, setGrid] = useState(4);
  const productState = useSelector((state) => state?.product?.product);
   console.log(productState,"product")
     const [showFilter, setShowFilter] = useState(false); 
  
  const isDesktop = useMediaQuery({ minWidth: 768 });

  // Filter States
  const [tag, setTag] = useState(null)
  const [category, setCategory] = useState(null)
  const [brand, setBrand] = useState(null)
  const [minPrice,setMinPrice]=useState(null)
  const [maxPrice, setMaxPrice] = useState(null)
  const [sort,setSort]=useState(null)
  const [vehicleBrand, setVehicleBrand] = useState("");
  const [brandModel, setBrandModel] = useState("");
  const [minYear, setMinYear] = useState("");
  const [maxYear, setMaxYear] = useState("");
  const [selectedEngineSize, setSelectedEngineSize] = useState(null);
  const [year,setYear] = useState("")
  
  const [selectedBudget, setSelectedBudget] = useState(null);
 const navigate=useNavigate();
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("search");

  const [filteredProducts, setFilteredProducts] = useState([]);




  const dispatch = useDispatch();
  useEffect(() => {
    getProducts();
  }, [sort, tag, brand, category, minPrice, maxPrice,]);
  const getProducts = () => {
    dispatch(getAllProducts({ sort, tag, brand, category, minPrice, maxPrice }));
   };

 
    
    useEffect(() => {
    if (!productState) return;

    const enroute = productState.filter(
      (item) => item.market?.toLowerCase() === "enroute"
    );

    setFilteredProducts(enroute);
  }, [productState]);
    

  
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 20;
  const pageCount = Math.ceil(filteredProducts.length / itemsPerPage);

const handlePageChange = (selectedPage) => {
  setCurrentPage(selectedPage.selected);
  window.scrollTo({ top: 0, behavior: 'smooth' });  
};


  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = Array.isArray(filteredProducts)
  ? filteredProducts.slice(startIndex, endIndex)
  : [];  

 

 useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const engineSize = queryParams.get("engine_size");  
  
    if (engineSize) {
      setSelectedEngineSize(engineSize); 
    }
  
   
  }, [location.search]);
 
  const handleSubmit = (e) => {
    e.preventDefault();
  
    const params = {
      search: searchQuery && searchQuery !== "null" ? searchQuery : undefined,
      vehicle_brand: vehicleBrand,
      brand_model: brandModel || undefined,
      year_of_manufacture__gte: minYear || undefined,
      year_of_manufacture__lte: maxYear || undefined,
      min_price: selectedBudget ? selectedBudget[0] : undefined,
      max_price: selectedBudget ? selectedBudget[1] : undefined,
      engine_size: selectedEngineSize || undefined,  
      sort: sort || undefined,
    };
  
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== "")
    );
  
    navigate(`/search?${new URLSearchParams(filteredParams).toString()}`, { replace: true });
  };
  
  
  const handleBackButtonClick = () => {
    setShowFilter(false);
    document.body.style.overflow = "auto";  
  };


  const toggleFilter = () => {
    setShowFilter(prev => {
      const newShowFilter = !prev;
      document.body.style.overflow = newShowFilter ? "hidden" : "auto";
      return newShowFilter;
    });
  };

  
   const handleSearch = () => {
   
     document.body.style.overflow = "auto"
   }
 

     const renderFilter = () => {
        return (
          <div className="shop-by-media">
        
                    <div className="filter-back-btn-wrapper">
              <Link 
                className="filter-btn-container1"
                onClick={handleBackButtonClick}>
                <MdKeyboardBackspace className="filter-back-icon" />
                <h2>Filter</h2>
              </Link>
            </div>
          <form onSubmit={handleSubmit} className="media-filter  filter-main-wrapper">
          <div className="filter-card-el">
            <h3 className="filter-title">Brand & Model</h3>
            <div className="d-flex flex-column align-items-center gap-10">
              {/* Brand Dropdown */}
              <div className="form-floating w-100">
                <select
                  className="form-select"
                  value={vehicleBrand}
                  onChange={handleBrandChange}
                 
                >
                  <option value="">Select Brand</option>
                  {Object.keys(brandByModel).map((brand) => (
                    <option key={brand} value={brand}>
                      {brand}
                    </option>
                  ))}
                </select>
                <label htmlFor="floatingSelect">Brand</label>
              </div>
        
              {/* Model Dropdown */}
              <div className="form-floating w-100">
                <select
                  className="form-select"
                  value={brandModel}
                  onChange={(e) => setBrandModel(e.target.value)}
                  disabled={!vehicleBrand} 
                >
                  <option value="">Select Model</option>
                  {brandByModel[vehicleBrand]?.map((model, index) => (
                    <option key={index} value={model}>
                      {model}
                    </option>
                  ))}
                </select>
                <label htmlFor="floatingSelect">Model</label>
              </div>
            </div>
          </div>
        
          <div className="filter-card-el">
            <h3 className="filter-title">Year of Manufacture</h3>
            <div className="d-flex align-items-center gap-10">
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Min YOM"
                  value={minYear}
                  onChange={(e) => setMinYear(e.target.value)}
                />
                <label htmlFor="floatingInput">Min YOM</label>
              </div>
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Max YOM"
                  
                  value={maxYear}
                  onChange={(e) => setMaxYear(e.target.value)}
                />
                <label htmlFor="floatingInput1">Max YOM</label>
              </div>
            </div>
          </div>
    
          <div className="filter-card-el">
      <h3 className="filter-title">Filter by Engine Size</h3>
      <div className="engine-size-container   ">
        <ul className="mt-3">
          {engineSizes.map((size, index) => (
            <li key={index}>
            <button 
              className={`btn ${selectedEngineSize?.trim().toLowerCase() === size.trim().toLowerCase() ? "selected-size" : " "}`}
              onClick={() => handleEngineSizeFilter(size)}
            >
              {size}
            </button>
    
    
            </li>
          ))}
        </ul>
      </div>
    </div>
        
          {/* Filter by Budget */}
          <div className="filter-card-el mb-3">
            <h3 className="filter-title">Filter by Budget</h3>
            <ul className="budget-filter-element">
              <li
                className={selectedBudget?.[0] === 0 && selectedBudget?.[1] === 500000 ? 'selected' : ''}
                onClick={() => handleBudgetFilter(0, 500000)}
              >
                0-500K
              </li>
              <li
                className={selectedBudget?.[0] === 500000 && selectedBudget?.[1] === 1000000 ? 'selected' : ''}
                onClick={() => handleBudgetFilter(500000, 1000000)}
              >
                500K-1M
              </li>
              <li
                className={selectedBudget?.[0] === 1000000 && selectedBudget?.[1] === 2000000 ? 'selected' : ''}
                onClick={() => handleBudgetFilter(1000000, 2000000)}
              >
                1M-2M
              </li>
              <li
                className={selectedBudget?.[0] === 2000000 && selectedBudget?.[1] === 3000000 ? 'selected' : ''}
                onClick={() => handleBudgetFilter(2000000, 3000000)}
              >
                2M-3M
              </li>
              <li
                className={selectedBudget?.[0] === 3000000 && selectedBudget?.[1] === 5000000 ? 'selected' : ''}
                onClick={() => handleBudgetFilter(3000000, 5000000)}
              >
                3M-5M
              </li>
              <li
                className={selectedBudget?.[0] === 5000000 && selectedBudget?.[1] === 10000000 ? 'selected' : ''}
                onClick={() => handleBudgetFilter(5000000, 10000000)}
              >
                5M-10M
              </li>
              <li
                className={selectedBudget?.[0] === 10000000 && selectedBudget?.[1] === Infinity ? 'selected' : ''}
                onClick={() => handleBudgetFilter(10000000, Infinity)}
              >
                Above 10M
              </li>
              {selectedBudget && (
                <button type="button" className="clear-btn" onClick={clearBudgetFilter}>
                  Clear
                </button>
              )}
            </ul>
          </div>
        
          <button type="submit" className="btn" onClick={handleSearch}>Search</button>
        </form>
          </div>
    
                 
        );
    };
    
  

  const handleBrandChange = (e) => {
    setVehicleBrand(e.target.value);
    setBrandModel("");  
  };

  const handleBudgetFilter = (min, max) => {
    setSelectedBudget([min, max]);
    setMinPrice(min);
    setMaxPrice(max);
};


  const clearBudgetFilter = () => {
    setSelectedBudget(null);
 
  };


  const engineSizes = Array.from(
    new Set(productState?.map(item => item.engineSize?.title).filter(Boolean))  
  );
  
   
  const handleEngineSizeFilter = (size) => {
    setSelectedEngineSize(size);
     document.body.style.overflow = "auto"
   };

 
 
 

  return (
    <>
      <Meta title={"Enroute Vehicles"} />
      <BreadCrumb title="Enroute Vehicles" />
      <Container class1="search-wrapper home-wrapper-2 py-5">
        <div className="row vehicle-row ">
          
          <div className=" search-container  position-relative">
        <FilterForm/>

                            <p className="totalproducts">{filteredProducts.length} Vehicles</p>

            <div className="products-list   ">
                         {currentItems.length === 0 ? (
                 <div className="no-results">
                   <img src={noResults} alt="no results gif"/>
                  </div>
               ) : (
         <>           
            {isDesktop ? (

            <>
            <div className="grid-section grid-four">
              {currentItems.slice(0, 20).map((product, index) => (
                <ProductCard key={index} data={product} grid={grid} />
              ))}
            </div>

            </>):(
         <div className="search-list ">
         {currentItems.map((product, index) => (
           <ProductCard key={index} data={product}  />
         ))}
       </div>
)}
</> )}

            </div>


          </div>
        </div>
     
            
            <Pagination
            pageCount={pageCount}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />

        {showFilter && renderFilter()} 

      </Container>


    </>
  );
};

export default Enroute;
